import clsx from 'clsx';
import { Loader2 } from 'lucide-react';

type SpinnerProps = {
  size?: number;
  className?: string;
};

export function Spinner({ size = 32, className }: SpinnerProps) {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2
        className={clsx('text-fx-primary animate-spin', className)}
        size={size}
      />
    </div>
  );
}
